import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { childrenInventoryPageBreadcrumbs } from '@/pages/Inventory/config';
import { NavigateFunction } from 'react-router-dom';

export const assignmentsPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenInventoryPageBreadcrumbs(navigate),
  { label: 'Asignaciones', onClick: () => navigate('/inventory/assignments') },
];
